import React from 'react';
import { Button, CircularProgress } from '@material-ui/core';

const FileUploadButton = ({
	onChange,
	image,
	text,
	value,
	accept,
	color,
	textStyle,
	icon,
	disabled,
	buttonStyle,
	trigger,
	flat,
	id = 'raised-button-file',
	loading,
	loadingColor = 'inherit',
	style
}) => (
	<React.Fragment>
		<input
			type="file"
			{...(image ? { accept: 'image/*' } : {})}
			{...(accept ? { accept } : {})}
			id={id}
			value={value}
			onChange={onChange}
			disabled={disabled}
			{...(loading ? { disabled: true } : {})}
			style={{
				cursor: 'pointer',
				position: 'absolute',
				top: 0,
				width: 0,
				bottom: 0,
				right: 0,
				left: 0,
				opacity: 0
			}}
		/>
		{trigger ?
			<label htmlFor={id} style={style}>
				{trigger()}
			</label>
			:
			<label htmlFor={id} style={style}>
				<Button
					variant={flat ? 'flat' : 'raised'}
					component="span"
					disableRipple={loading}
					disabled={loading}
					style={{
						...buttonStyle,
						...textStyle,
						backgroundColor: color
					}}
				>
					{text}
					{loading ? (
						<div
							style={{
								color: 'white',
								marginLeft: '0.3em'
							}}
						>
							<CircularProgress size={12} color={loadingColor} />
						</div>
					) : (
						icon
					)}
				</Button>
			</label>
		}
	</React.Fragment>
);

export default FileUploadButton;
